(function () {
  'use strict';

  var config = window.dsrcvDeliveryPromiseConfig || {};
  var mode = config.mode || 'order_deadline';
  var cartMode = config.cartMode || mode;
  var refreshTimer = null;
  var lastCartRender = null;
  var lastProductRender = null;
  var legacyObserver = null;
  var coreAvailable = { product: false, cart: false };
  var requestGeneration = { product: 0, cart: 0 };
  var promiseResponseCache = {};
  var promiseResponsePending = {};
  var PROMISE_TIMEOUT_MS = 8000;
  var comparisonSignatures = {};
  var PRODUCT_SELECTOR = '.ProductForm > .trustblox-1-timer-textual, .ProductForm > .trustblox-1-timer-wrap';
  var CART_SELECTOR = '.trustblox-1-viewcart-wrap:not([data-dsrcv-delivery-promise])';

  if (!config.apiUrl) {
    return;
  }

  function modeForSurface(surface) {
    return surface === 'cart' ? cartMode : mode;
  }

  function normalizeText(value) {
    return String(value || '').replace(/\s+/g, ' ').trim();
  }

  function messageText(node) {
    if (!node) return '';
    var clone = node.cloneNode(true);
    var removable = clone.querySelectorAll('.trustblox-1-timer-locations-toggle, .trustblox-timer');
    Array.prototype.forEach.call(removable, function (element) {
      if (element.parentNode) element.parentNode.removeChild(element);
    });
    var message = clone.querySelector('.trustblox-message');
    return normalizeText((message || clone).textContent);
  }

  function nodeIsVisible(node) {
    if (!node) return false;
    var style = window.getComputedStyle(node);
    return style.display !== 'none' && style.visibility !== 'hidden' && node.getClientRects().length > 0;
  }

  function findLegacyNode(surface, visibleOnly) {
    var selector = surface === 'product' ? PRODUCT_SELECTOR : CART_SELECTOR;
    var nodes = document.querySelectorAll(selector);
    for (var index = 0; index < nodes.length; index += 1) {
      if (
        !nodes[index].hasAttribute('data-dsrcv-delivery-promise') &&
        messageText(nodes[index]) &&
        (!visibleOnly || nodeIsVisible(nodes[index]))
      ) {
        return nodes[index];
      }
    }
    return null;
  }

  function setLegacyHidden(hidden, surface) {
    var selectors = surface === 'product' ? [PRODUCT_SELECTOR] : surface === 'cart' ? [CART_SELECTOR] : [PRODUCT_SELECTOR, CART_SELECTOR];
    selectors.forEach(function (selector) {
      var nodes = document.querySelectorAll(selector);
      Array.prototype.forEach.call(nodes, function (node) {
        if (node.hasAttribute('data-dsrcv-delivery-promise')) return;
        if (hidden) {
          node.setAttribute('data-dsrcv-delivery-promise-legacy-hidden', 'true');
          node.style.setProperty('display', 'none', 'important');
        } else if (node.getAttribute('data-dsrcv-delivery-promise-legacy-hidden') === 'true') {
          node.removeAttribute('data-dsrcv-delivery-promise-legacy-hidden');
          node.style.removeProperty('display');
        }
      });
    });
  }

  function writeProductCalendar(message) {
    var copies = document.querySelectorAll('[data-pdp-free-delivery-copy]');
    Array.prototype.forEach.call(copies, function (copy) {
      if (copy.textContent !== message) copy.textContent = message;
      var row = copy.closest('[data-pdp-free-delivery-message]');
      if (row) row.hidden = false;
    });
    return copies.length > 0;
  }

  function removeCoreNodes(surface) {
    if (surface === 'product') {
      renderProductCondition(null);
      writeProductCalendar(productFallbackMessage());
    }
    var selector = '[data-dsrcv-delivery-promise="' + surface + '"]';
    Array.prototype.forEach.call(document.querySelectorAll(selector), function (node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });
  }

  function productFallbackMessage() {
    if (productIsPreorder()) return config.strings && config.strings.preorderDeliveryDetails || 'Pre-order delivery details at checkout';
    if (!selectedProductVariantIsAvailable()) return productFreeDeliveryMessage();
    return config.strings && config.strings.deliveryDetails || 'Delivery details at checkout';
  }

  function productFreeDeliveryMessage() {
    var api = window.__FreeShippingBarAPI;
    var quote = api && typeof api.getQuote === 'function' ? api.getQuote() : null;
    var pending = api && typeof api.isLoading === 'function' && api.isLoading();
    if (!pending && quote && quote.available === true && quote.countryCode === cartCountry() &&
        quote.currency === currentCurrency() && quote.reason !== 'free_threshold_not_unique' &&
        Number.isSafeInteger(quote.freeThresholdCents) && quote.freeThresholdCents > 0 &&
        Number.isSafeInteger(quote.subtotalCents) && quote.subtotalCents >= 0 &&
        Number.isSafeInteger(quote.remainingCents) &&
        quote.remainingCents === Math.max(0, quote.freeThresholdCents - quote.subtotalCents)) {
      var amount = new Intl.NumberFormat(config.locale || 'en', {
        style: 'currency', currency: quote.currency,
        minimumFractionDigits: quote.freeThresholdCents % 100 === 0 ? 0 : 2
      }).format(quote.freeThresholdCents / 100);
      return (config.strings && config.strings.freeDeliveryFrom || 'Free delivery from [[amount]]').replace('[[amount]]', amount);
    }
    return config.strings && config.strings.deliveryDetails || 'Delivery details at checkout';
  }

  function productDisplayContext() {
    return [String(config.productId), cartCountry(), currentCurrency(), currentClockKey(),
      productIsPreorder(), selectedProductVariantIsAvailable()].join('|');
  }

  function prepareProductRender(invalidate) {
    if (invalidate || (lastProductRender && lastProductRender.context !== productDisplayContext())) {
      lastProductRender = null;
    }
    if (!lastProductRender) removeCoreNodes('product');
  }

  function renderProduct(result) {
    var resolvedMessage = productPromiseMessage(result);
    renderProductCondition(resolvedMessage ? result : null);
    if (writeProductCalendar(resolvedMessage || productFallbackMessage())) return;
    var existing = document.querySelector('[data-dsrcv-delivery-promise="product"]');
    if (!resolvedMessage) {
      if (existing) existing.remove();
      return;
    }
    if (existing) {
      var existingMessage = existing.querySelector('.trustblox-message');
      if (existingMessage && existingMessage.textContent !== resolvedMessage) existingMessage.textContent = resolvedMessage;
      return;
    }
    var form = document.querySelector('.ProductForm');
    if (!form) return;
    var node = document.createElement('div');
    node.className = 'trustblox-1-timer-textual trustblox-1-style-bordered';
    node.setAttribute('data-dsrcv-delivery-promise', 'product');
    node.style.setProperty('display', 'block', 'important');
    var message = document.createElement('div');
    message.className = 'trustblox-message';
    message.textContent = resolvedMessage;
    node.appendChild(message);
    var anchor = form.querySelector('.ProductMeta__CustomContentContainer');
    if (anchor && anchor.parentNode === form) form.insertBefore(node, anchor.nextSibling);
    else form.appendChild(node);
  }

  function renderProductCondition(result) {
    var text = '';
    if (result && cartCountry() === 'GB') {
      var dispatch = dateFromKey(result.dispatchDate);
      var now = londonNowParts();
      var today = new Date(Date.UTC(now.year, now.month - 1, now.day, 12));
      if (dispatch && dispatch >= today) {
        var sameDayHandling = Array.isArray(result.handlingDays) && result.handlingDays.length > 0 &&
          result.handlingDays.every(function (days) { return days === 0; });
        var localCutoff = sameDayHandling && result.cutoffPassed === false && dateKey(dispatch) === dateKey(today) && now.hour < cutoffHour()
          ? internationalCutoffLabel({ now: now }, true) : '';
        text = localCutoff || (config.strings && config.strings.despatch || 'Despatch') + ' ' + formatPromiseDate(dispatch, 'GB');
      }
    }
    document.querySelectorAll('[data-pdp-free-delivery-copy]').forEach(function (copy) {
      var condition = copy.parentNode.querySelector('[data-pdp-delivery-condition]');
      if (!text) {
        if (condition) condition.remove();
        return;
      }
      if (!condition) {
        condition = document.createElement('small');
        condition.setAttribute('data-pdp-delivery-condition', '');
        condition.style.cssText = 'display:block;font-size:12px;line-height:1.5;margin-top:2px;color:#575351';
        copy.parentNode.appendChild(condition);
      }
      if (condition.textContent !== text) condition.textContent = text;
    });
  }

  function dateFromKey(value) {
    var match = String(value || '').match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (!match) return null;
    var date = new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, Number(match[3]), 12));
    return !Number.isNaN(date.getTime()) && dateKey(date) === value ? date : null;
  }

  function dateKey(date) {
    return [date.getUTCFullYear(), String(date.getUTCMonth() + 1).padStart(2, '0'), String(date.getUTCDate()).padStart(2, '0')].join('-');
  }

  function addDays(date, days) {
    var next = new Date(date.getTime());
    next.setUTCDate(next.getUTCDate() + days);
    return next;
  }

  function currentTime() {
    return config.now ? new Date(config.now) : new Date();
  }

  function zonedParts(now, timeZone) {
    var parts = new Intl.DateTimeFormat('en-GB', {
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23', timeZone: timeZone
    }).formatToParts(now);
    var values = {};
    parts.forEach(function (part) {
      if (part.type !== 'literal') values[part.type] = Number(part.value);
    });
    return values;
  }

  function londonNowParts() {
    return zonedParts(currentTime(), config.warehouseTimeZone || 'Europe/London');
  }

  function cutoffHour() {
    var hour = Number(config.cutoffHour);
    return Number.isFinite(hour) ? hour : 12;
  }

  function clockLabel(parts) {
    return (parts.hour % 12 || 12) + (parts.minute ? ':' + String(parts.minute).padStart(2, '0') : '') +
      (parts.hour >= 12 ? 'pm' : 'am');
  }

  function internationalCutoffLabel(dispatch, productNote) {
    var warehouseZone = config.warehouseTimeZone || 'Europe/London';
    // Convert today's warehouse wall-clock deadline to an instant. Query the
    // zone on this date, never assume a fixed GMT/BST or destination offset.
    var wallTime = Date.UTC(dispatch.now.year, dispatch.now.month - 1, dispatch.now.day, cutoffHour());
    var instant = new Date(wallTime);
    for (var attempt = 0; attempt < 2; attempt += 1) {
      var parts = zonedParts(instant, warehouseZone);
      var represented = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute, parts.second);
      instant = new Date(instant.getTime() + wallTime - represented);
    }
    try {
      // Country is insufficient for places such as the US and Australia.
      // Resolve again on each render so device-zone changes are respected too.
      var zone = new Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!zone) throw new Error('Device timezone unavailable');
      var localCutoff = zonedParts(instant, zone);
      var localNow = zonedParts(currentTime(), zone);
      var cutoffDay = Date.UTC(localCutoff.year, localCutoff.month - 1, localCutoff.day);
      var today = Date.UTC(localNow.year, localNow.month - 1, localNow.day);
      var dayLabel = cutoffDay === today ? 'today' : cutoffDay === today + 86400000 ? 'tomorrow' :
        'on ' + new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', timeZone: zone }).format(instant);
      if (productNote) {
        var strings = config.strings || {};
        var localDay = cutoffDay === today ? (strings.cutoffToday || 'today') : cutoffDay === today + 86400000
          ? (strings.cutoffTomorrow || 'tomorrow') : (strings.cutoffOnDate || 'on [[date]]').replace('[[date]]',
            new Intl.DateTimeFormat(config.locale || 'en-GB', { day: 'numeric', month: 'long', timeZone: zone }).format(instant));
        var localClock = config.locale && !/^en(?:-|$)/i.test(config.locale)
          ? new Intl.DateTimeFormat(config.locale, { hour: 'numeric', minute: '2-digit', timeZone: zone }).format(instant)
          : clockLabel(localCutoff);
        return (strings.orderBeforeLocal || 'Order before [[time]] [[day]]')
          .replace('[[time]]', localClock).replace('[[day]]', localDay);
      }
      return 'Order before ' + clockLabel(localCutoff) + ' ' + dayLabel + ' · your local time';
    } catch (error) {
      // Never silently label UK noon as the shopper's local noon.
      return productNote ? '' : 'Order before ' + clockLabel({ hour: cutoffHour(), minute: 0 }) + ' today · UK time';
    }
  }

  function formatPromiseDate(date, country) {
    return new Intl.DateTimeFormat(config.locale && !/^en(?:-|$)/i.test(config.locale) ? config.locale : country === 'US' ? 'en-US' : 'en-GB', {
      weekday: 'long', day: 'numeric', month: 'long', timeZone: 'UTC'
    }).format(date);
  }

  function isTomorrow(date, dispatchState) {
    var today = new Date(Date.UTC(dispatchState.now.year, dispatchState.now.month - 1, dispatchState.now.day, 12));
    return dateKey(date) === dateKey(addDays(today, 1));
  }

  function deliveryPromiseMessage(result) {
    return result && result.visible === true && result.message ? normalizeText(result.message).replace(/[.]$/, '') : '';
  }

  function productPromiseMessage(result) {
    if (!result || result.visible !== true || productIsPreorder() || !selectedProductVariantIsAvailable()) return '';
    if (cartCountry() !== 'GB') {
      var dispatch = dateFromKey(result.dispatchDate);
      var now = londonNowParts();
      var today = new Date(Date.UTC(now.year, now.month - 1, now.day, 12));
      return dispatch && dispatch >= today ? (config.strings && config.strings.despatch || 'Despatch') + ' ' + formatPromiseDate(dispatch, cartCountry()) : '';
    }
    if (result.deliveryDateMin || result.deliveryDateMax) {
      var first = dateFromKey(result.deliveryDateMin);
      var last = dateFromKey(result.deliveryDateMax);
      if (!first || !last || last < first) return '';
      // The API message can name only the earliest day of a wider window.
      // Use its complete calculated range instead of promising that first day.
      if (dateKey(first) !== dateKey(last)) {
        return (config.strings && config.strings.estimatedDelivery || 'Estimated delivery') + ' ' + formatPromiseDate(first, cartCountry()) + ' ' + (config.strings && config.strings.dateRangeTo || 'to') + ' ' + formatPromiseDate(last, cartCountry());
      }
      var label = cartCountry() === 'GB'
        ? (config.strings && config.strings.delivery || 'Delivery')
        : (config.strings && config.strings.estimatedDelivery || 'Estimated delivery');
      return label + ' ' + formatPromiseDate(first, cartCountry());
    }
    return deliveryPromiseMessage(result);
  }

  function currentCurrency() {
    return String(window.Shopify && window.Shopify.currency && window.Shopify.currency.active || config.currencyCode || 'GBP').toUpperCase();
  }
  function currentClockKey() {
    var now = londonNowParts();
    return [now.year, now.month, now.day, now.hour < cutoffHour() ? 'before' : 'after'].join(':');
  }

  function cartCountry() {
    return String((window.Shopify && window.Shopify.country) || config.countryCode || document.body.getAttribute('data-country') || '').toUpperCase();
  }

  // Cart dates use the warehouse cutoff, not the destination's local clock.
  // A missing calendar is not evidence that delivery is unavailable: omit
  // the date until a current promise or verified service can be shown.

  function cartPromiseMessage(state) {
    if (!state || !state.itemCount) return '';
    var result = lastCartRender && lastCartRender.result;
    var now = londonNowParts();
    var today = new Date(Date.UTC(now.year, now.month - 1, now.day, 12));
    // International orders need a warehouse dispatch date, not an arrival claim.
    if (state.countryCode !== 'GB') {
      if (state.hasPreorder) return 'Ships together once all pieces are available';
      var dispatch = result && result.visible === true && dateFromKey(result.dispatchDate);
      return dispatch && dispatch >= today ? 'Ships ' + formatPromiseDate(dispatch, state.countryCode) : '';
    }
    if (result && result.visible === true) {
      var first = dateFromKey(result.deliveryDateMin);
      var last = dateFromKey(result.deliveryDateMax);
      if (first && last && first >= today && last >= first) {
        var tomorrow = dateKey(first) === dateKey(addDays(today, 1)) && dateKey(first) === dateKey(last);
        var dates = (tomorrow && state.countryCode === 'GB' ? 'tomorrow, ' : '') + formatPromiseDate(first, state.countryCode);
        if (dateKey(first) !== dateKey(last)) dates += ' to ' + formatPromiseDate(last, state.countryCode);
        return (state.hasPreorder ? 'In-stock pieces delivered ' : 'Delivered ') + dates;
      }
      // A partial or invalid calendar window cannot become a dated promise
      // via the API's prose (which may name only its earliest day).
      return '';
    }
    if (state.hasPreorder) return state.countryCode === 'GB'
      ? 'Pre-orders dispatch on their listed dates' : 'Ships together once all pieces are available';
    var api = window.__FreeShippingBarAPI;
    var quote = api && typeof api.getQuote === 'function' ? api.getQuote() : null;
    if (quote && quote.available === true && quote.countryCode === state.countryCode &&
        quote.currency === state.currencyCode && quote.subtotalCents === state.subtotalCents) {
      return configuredTransitMessage(quote.transitWindowLabel) || normalizeText(quote.methodLabel).replace('Delivered Next Day Once Dispatched', 'Next day delivery once dispatched')
        .replace('No Import Charges On Delivery', 'No import charges on delivery').replace(/[.]$/, '');
    }
    return '';
  }

  // A current service window can describe transit after dispatch even when a
  // calendar date is unavailable. It cannot establish a dispatch date/cutoff.
  function configuredTransitMessage(label) {
    var value = normalizeText(label).replace(/\s*\(No Import Charges On Delivery\)\s*$/i, '').trim();
    var match = value.match(/^(\d+)(?:\s*[-\u2013]\s*(\d+))?\s+(working\s+|business\s+)?days?$/i);
    if (!match) return '';
    var min = Number(match[1]);
    var max = match[2] ? Number(match[2]) : min;
    if (!Number.isSafeInteger(min) || !Number.isSafeInteger(max) || min < 1 || max < min) return '';
    var days = min === max ? String(min) : min + '\u2013' + max;
    return 'Estimated delivery in ' + days + ' ' + (match[3] ? match[3].toLowerCase() : '') + (max === 1 ? 'day' : 'days') + ' after dispatch';
  }

  function renderCart(result, state, shippingQuote) {
    lastCartRender = { result: result, state: state, shippingQuote: shippingQuote };
    var resolvedMessage = cartPromiseMessage(state);
    var existing = document.querySelector('[data-dsrcv-delivery-promise="cart"] .trustblox-message');
    if (existing && existing.textContent === resolvedMessage) {
      // Consumers may have cleared their date while this basket refreshed.
      document.dispatchEvent(new CustomEvent('dsrcv:delivery-promise:rendered', {
        detail: { surface: 'cart' }
      }));
      return;
    }
    removeCoreNodes('cart');
    if (!resolvedMessage) return;
    var node = document.createElement('div');
    node.className = 'trustblox-1-viewcart-wrap dsrcv-delivery-promise-cart-source';
    node.setAttribute('data-dsrcv-delivery-promise', 'cart');
    var message = document.createElement('div');
    message.className = 'trustblox-1-viewcart-message trustblox-message';
    message.textContent = resolvedMessage;
    node.appendChild(message);
    document.body.appendChild(node);
    document.dispatchEvent(new CustomEvent('dsrcv:delivery-promise:rendered', {
      detail: { surface: 'cart' }
    }));
  }

  function isTruthyPreorderValue(value) {
    if (typeof value === 'boolean') return value;
    if (typeof value === 'number') return value !== 0;
    if (typeof value !== 'string') return Boolean(value);
    var normalized = value.trim().toLowerCase();
    return Boolean(normalized) && ['false', '0', 'no', 'n/a', 'none', 'null'].indexOf(normalized) === -1;
  }

  function isPreorderItem(item) {
    var properties = item && item.properties ? item.properties : {};
    var keys = Object.keys(properties);
    var explicitKey = keys.find(function (key) { return key.trim().toLowerCase() === '_preorder'; });
    if (explicitKey) return isTruthyPreorderValue(properties[explicitKey]);
    return keys.some(function (key) {
      var value = properties[key];
      if (!isTruthyPreorderValue(value)) return false;
      var normalizedKey = key.trim().toLowerCase();
      var normalizedValue = typeof value === 'string' ? value.trim().toLowerCase() : '';
      return normalizedKey.indexOf('pre-order') !== -1
        || normalizedKey.indexOf('preorder') !== -1
        || normalizedKey.indexOf('estimated shipping date') !== -1
        || normalizedValue.indexOf('pre-order') !== -1
        || normalizedValue.indexOf('preorder') !== -1
        || (normalizedKey === 'notice' && normalizedValue.indexOf('shipping date') !== -1);
    });
  }

  function hasExplicitFalsePreorder(item) {
    var properties = item && item.properties ? item.properties : {};
    var explicitKey = Object.keys(properties).find(function (key) { return key.trim().toLowerCase() === '_preorder'; });
    return Boolean(explicitKey) && !isTruthyPreorderValue(properties[explicitKey]);
  }

  function productIsPreorder() {
    if (config.templatePreorder) return true;
    var wrapper = document.querySelector('.custom-cart-wrapper');
    return !!(wrapper && wrapper.getAttribute('data-preorder-active') === 'true');
  }

  function productSelectionIsReady() {
    var wrapper = document.querySelector('.custom-cart-wrapper');
    if (!wrapper || wrapper.getAttribute('data-requires-selection') !== 'true') return true;
    return wrapper.getAttribute('data-variant-selected') === 'true';
  }

  function selectedProductVariantIsAvailable() {
    var form = document.querySelector('.ProductForm');
    var variantInput = form && form.querySelector('[name="id"]');
    var variantId = variantInput && String(variantInput.value || '').trim();
    var availability = config.variantAvailability || {};
    if (variantId && Object.prototype.hasOwnProperty.call(availability, variantId)) {
      return availability[variantId] !== false;
    }
    return config.productAvailable !== false;
  }

  function endpointUrl(surface, productIds, state) {
    var params = new URLSearchParams();
    params.set('country', state.countryCode || String(config.countryCode || 'GB').toUpperCase());
    params.set('currency', state.currencyCode || currentCurrency());
    params.set('subtotalCents', String(Math.max(0, Number(state.subtotalCents) || 0)));
    params.set('surface', surface);
    params.set('productIds', productIds.join(','));
    params.set('hasPreorder', state.hasPreorder ? 'true' : 'false');
    params.set('hasNonPreorder', state.hasNonPreorder ? 'true' : 'false');
    params.set('preorderLines', (state.preorderLines || []).join(','));
    params.set('available', state.available === false ? 'false' : 'true');
    return config.apiUrl + '?' + params.toString();
  }

  function requestPromise(surface, productIds, state) {
    // This endpoint supplies dates only. Shopify remains the source for rates
    // in presentment currency, including international Markets.
    var url = endpointUrl(surface, productIds, state);
    var cacheKey = url + '|' + currentClockKey();
    var cached = promiseResponseCache[cacheKey];
    if (cached && Date.now() - cached.cachedAt < 5000) {
      return Promise.resolve(Object.assign({}, cached.payload, { clientResponseMs: 0 }));
    }
    if (promiseResponsePending[cacheKey]) {
      return promiseResponsePending[cacheKey];
    }

    var startedAt = Date.now();
    var controller = typeof window.AbortController === 'function' ? new window.AbortController() : null;
    var requestOptions = {
      method: 'GET',
      mode: 'cors',
      credentials: 'omit',
      headers: { Accept: 'application/json' }
    };
    if (controller) requestOptions.signal = controller.signal;
    var timeoutId;
    var deadline = new Promise(function (_, reject) {
      timeoutId = window.setTimeout(function () {
        reject(new Error('Delivery promise timed out'));
        if (controller) controller.abort();
      }, PROMISE_TIMEOUT_MS);
    });
    var responseBody = Promise.resolve().then(function () {
      return fetch(url, requestOptions);
    }).then(function (response) {
      if (!response.ok) throw new Error('Delivery promise returned ' + response.status);
      return response.json();
    });
    // Race the complete body, so a stalled response cannot keep the page waiting.
    // Late responses never reach the successful cache or render consumers.
    promiseResponsePending[cacheKey] = Promise.race([responseBody, deadline]).then(function (payload) {
      payload.clientResponseMs = Date.now() - startedAt;
      promiseResponseCache[cacheKey] = { cachedAt: Date.now(), payload: payload };
      return payload;
    }).finally(function () {
      window.clearTimeout(timeoutId);
      delete promiseResponsePending[cacheKey];
    });

    return promiseResponsePending[cacheKey];
  }

  function readCart() {
    if (typeof window.dsrcvReadCart === 'function') {
      return window.dsrcvReadCart();
    }
    return fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (response) {
      if (!response.ok) throw new Error('Unable to read cart');
      return response.json();
    });
  }

  function sendComparison(surface, productIds, state, payload) {
    if (!config.compareUrl) return;
    var attempts = 0;
    var settle = function () {
      attempts += 1;
      var legacy = findLegacyNode(surface, surface === 'product');
      var appText = messageText(legacy);
      var appVisible = !!appText;
      if (surface === 'product' && legacy) {
        appVisible = appVisible && nodeIsVisible(legacy);
      }
      if (surface !== 'product') {
        appVisible = appVisible && state.hasNonPreorder && (!state.hasPreorder || String(config.countryCode).toUpperCase() === 'GB');
      }
      if ((!legacy || !appVisible) && payload.result && payload.result.visible && attempts < 24) {
        window.setTimeout(settle, 250);
        return;
      }
      if ((!legacy || !appVisible) && payload.result && payload.result.visible) return;
      var comparison = {
        themeId: String(config.themeId || ''),
        surface: surface,
        countryCode: String(config.countryCode || 'GB'),
        productIds: productIds,
        appVisible: appVisible,
        coreVisible: !!(payload.result && payload.result.visible),
        appText: appText || null,
        coreText: payload.result && payload.result.message ? payload.result.message : null,
        coreReason: payload.result ? payload.result.reason : null,
        coreProfileCode: payload.result ? payload.result.profileCode : null,
        adapterVersion: String(config.adapterVersion || 'unversioned'),
        rulesVersion: payload.rulesVersion ? String(payload.rulesVersion) : null,
        responseMs: payload.clientResponseMs
      };
      var signature = JSON.stringify([
        comparison.countryCode,
        comparison.productIds,
        comparison.appVisible,
        comparison.coreVisible,
        comparison.appText,
        comparison.coreText,
        comparison.coreReason,
        comparison.coreProfileCode,
        comparison.adapterVersion,
        comparison.rulesVersion
      ]);
      if (comparisonSignatures[surface] === signature) return;
      comparisonSignatures[surface] = signature;
      fetch(config.compareUrl, {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(comparison)
      }).catch(function () {
        if (comparisonSignatures[surface] === signature) delete comparisonSignatures[surface];
      });
    };
    settle();
  }

  function applyResult(surface, productIds, state, payload) {
    var surfaceMode = modeForSurface(surface);
    if (surfaceMode === 'order_deadline') return;
    if (surfaceMode === 'shadow') {
      sendComparison(surface, productIds, state, payload);
      return;
    }
    coreAvailable[surface] = true;
    setLegacyHidden(true, surface);
    if (surface === 'product') {
      lastProductRender = { result: payload.result, context: productDisplayContext(), subtotalCents: state.subtotalCents };
      renderProduct(payload.result);
    }
    else renderCart(payload.result, Object.assign({}, state, {
      hasPreorder: state.hasPreorder || payload.preorderDetected === true,
      hasNonPreorder: typeof payload.nonPreorderDetected === 'boolean'
        ? payload.nonPreorderDetected
        : state.hasNonPreorder && !(payload.preorderDetected === true && !state.hasPreorder),
      unresolvedPreorder: payload.preorderDetected === true && !state.hasPreorder
    }), payload.shippingQuote);
  }

  function handleFailure(surface, state) {
    if (modeForSurface(surface) !== 'core') return;
    coreAvailable[surface] = false;
    if (surface === 'product') lastProductRender = null;
    removeCoreNodes(surface);
    setLegacyHidden(true, surface);
    if (!state || state.available === false || (surface === 'product' && state.hasPreorder)) return;
    if (surface === 'product') renderProduct(null);
    else renderCart(null, state, null);
  }

  function refreshProduct() {
    var generation = requestGeneration.product + 1;
    requestGeneration.product = generation;
    if (modeForSurface('product') === 'order_deadline') return Promise.resolve();
    if (!config.productId || !document.querySelector('.ProductForm')) return Promise.resolve();
    if (modeForSurface('product') === 'core') {
      setLegacyHidden(true, 'product');
      prepareProductRender(false);
    }
    if (modeForSurface('product') === 'shadow' && !productSelectionIsReady()) {
      return Promise.resolve();
    }
    var isPreorder = productIsPreorder();
    var state = {
      hasPreorder: isPreorder,
      hasNonPreorder: !isPreorder,
      available: selectedProductVariantIsAvailable(),
      preorderLines: (function () {
        var form = document.querySelector('.ProductForm');
        var input = form && form.querySelector('[name="id"]');
        var value = input && String(input.value || '').trim();
        return /^\d+$/.test(value || '') ? [value + ':' + (isPreorder ? 't' : 'n')] : [];
      })()
    };
    // The canonical calculator thresholds post-discount cart.total_price.
    return readCart().then(function (cart) {
      if (generation !== requestGeneration.product) return null;
      state.countryCode = cartCountry();
      state.clockKey = currentClockKey();
      state.subtotalCents = cart && cart.total_price;
      state.currencyCode = String(cart && cart.currency || currentCurrency()).toUpperCase();
      if (!Number.isSafeInteger(state.subtotalCents) || state.subtotalCents < 0 || state.currencyCode !== currentCurrency()) throw new Error('Invalid cart currency or subtotal');
      if (lastProductRender && lastProductRender.subtotalCents !== state.subtotalCents) prepareProductRender(true);
      return requestPromise('product', [String(config.productId)], state);
    })
      .then(function (payload) {
        if (generation !== requestGeneration.product) return;
        if (state.clockKey !== currentClockKey() || state.countryCode !== cartCountry() || state.currencyCode !== currentCurrency()) return refreshProduct();
        applyResult('product', [String(config.productId)], state, payload);
      })
      .catch(function () {
        if (generation !== requestGeneration.product) return;
        handleFailure('product', state);
      });
  }

  function drawerCartKey() {
    var drawer = document.getElementById && document.getElementById('sidebar-cart');
    if (!drawer) return null;
    return Array.prototype.map.call(drawer.querySelectorAll('[data-native-ucd-line-quantity]'), function (input) {
      return String(input.getAttribute('data-line-id') || '') + ':' + String(input.value || '');
    }).sort().join('|');
  }

  function canReuseCartRender() {
    var state = lastCartRender && lastCartRender.state;
    var key = drawerCartKey();
    return !!state && state.countryCode === cartCountry() && state.currencyCode === currentCurrency() && state.clockKey === currentClockKey() && !!state.cartKey && key === state.cartKey;
  }

  function clearCartRender() {
    lastCartRender = null;
    removeCoreNodes('cart');
    document.dispatchEvent(new CustomEvent('dsrcv:delivery-promise:rendered', { detail: { surface: 'cart' } }));
  }

  function refreshCart(preserveCurrent) {
    var generation = requestGeneration.cart + 1;
    var cartState = null;
    requestGeneration.cart = generation;
    var retainCurrent = preserveCurrent === true && canReuseCartRender();
    if (modeForSurface('cart') === 'order_deadline') return Promise.resolve();
    if (retainCurrent) renderCart(lastCartRender.result, lastCartRender.state, lastCartRender.shippingQuote);
    else clearCartRender();
    return readCart().then(function (cart) {
      if (generation !== requestGeneration.cart) return;
      if (!cart || !Number.isSafeInteger(cart.total_price) || cart.total_price < 0 || String(cart.currency || currentCurrency()).toUpperCase() !== currentCurrency()) throw new Error('Invalid cart context');
      var items = cart && Array.isArray(cart.items) ? cart.items : [];
      var preorderItems = items.filter(isPreorderItem);
      var ordinaryItems = items.filter(function (item) { return !isPreorderItem(item); });
      var productIds = ordinaryItems.map(function (item) { return String(item.product_id); }).filter(function (value, index, values) {
        return value && values.indexOf(value) === index;
      });
      var state = cartState = {
        itemCount: items.length,
        cartKey: items.map(function (item) { return String(item.key || '') + ':' + String(item.quantity || 0); }).sort().join('|'),
        countryCode: cartCountry(),
        currencyCode: String(cart.currency || currentCurrency()).toUpperCase(),
        clockKey: currentClockKey(),
        preorderItems: preorderItems,
        hasPreorder: preorderItems.length > 0,
        hasNonPreorder: ordinaryItems.length > 0,
        available: true,
        subtotalCents: Number(cart && cart.total_price) || 0,
        preorderLines: items.map(function (item) {
          var variantId = String(item && item.variant_id || '').trim();
          if (!/^\d+$/.test(variantId)) return '';
          return variantId + ':' + (isPreorderItem(item) ? 't' : hasExplicitFalsePreorder(item) ? 'f' : 'n');
        }).filter(Boolean)
      };
      if (retainCurrent && (state.countryCode !== lastCartRender.state.countryCode || state.cartKey !== lastCartRender.state.cartKey || state.subtotalCents !== lastCartRender.state.subtotalCents)) clearCartRender();
      if (!productIds.length) {
        if (modeForSurface('cart') === 'core') {
          coreAvailable.cart = true;
          setLegacyHidden(true, 'cart');
          renderCart(null, state, null);
        }
        return;
      }
      return requestPromise('cart_drawer', productIds, state)
        .then(function (payload) {
          if (generation !== requestGeneration.cart) return;
          if (state.clockKey !== currentClockKey() || state.countryCode !== cartCountry() || state.currencyCode !== currentCurrency()) return refreshCart();
          applyResult('cart', productIds, state, payload);
        });
    }).catch(function () {
      if (generation !== requestGeneration.cart) return;
      handleFailure('cart', cartState);
    });
  }

  function scheduleRefresh(event) {
    requestGeneration.product += 1;
    requestGeneration.cart += 1;
    clearCartRender();
    if (modeForSurface('product') === 'core') {
      var type = event && event.type || '';
      prepareProductRender(/^(?:cart:|currency:|covCurrency:|product:added|Upside::)/.test(type));
    }
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshProduct();
      refreshCart();
    }, 180);
  }

  function keepLegacyHidden() {
    if (modeForSurface('product') === 'core') setLegacyHidden(true, 'product');
    if (modeForSurface('cart') === 'core') setLegacyHidden(true, 'cart');
  }

  function mutationIncludesLegacyNode(mutation) {
    var selector = PRODUCT_SELECTOR + ', ' + CART_SELECTOR;
    var target = mutation && mutation.target;
    if (
      mutation.type === 'attributes' &&
      target &&
      target.nodeType === 1 &&
      target.matches(selector)
    ) {
      return true;
    }
    return Array.prototype.some.call(mutation.addedNodes || [], function (node) {
      return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
    });
  }

  function refreshWhenLegacyArrives(mutations) {
    if (modeForSurface('product') !== 'shadow' && modeForSurface('cart') !== 'shadow') return;
    if (Array.prototype.some.call(mutations, mutationIncludesLegacyNode)) scheduleRefresh();
  }

  function start() {
    refreshProduct();
    refreshCart();

    // Recalculate locally at minute boundaries; no recurring network requests.
    function tickCartClock() {
      if (!document.hidden && lastCartRender && modeForSurface('cart') === 'core') {
        if (lastCartRender.state.countryCode !== cartCountry() || lastCartRender.state.currencyCode !== currentCurrency() || lastCartRender.state.clockKey !== currentClockKey()) { refreshProduct(); refreshCart(); }
        else renderCart(lastCartRender.result, lastCartRender.state, lastCartRender.shippingQuote);
      }
      window.setTimeout(tickCartClock, 60000 - Date.now() % 60000);
    }
    window.setTimeout(tickCartClock, 60000 - Date.now() % 60000);
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) { refreshProduct(); refreshCart(); }
    });
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () { scheduleRefresh(); }).observe(document.body, {
        attributes: true, attributeFilter: ['data-country']
      });
    }

    ['cart:refresh', 'cart:updated', 'cart:change', 'currency:change', 'covCurrency:updated', 'product:added', 'product:variant-changed', 'variant:changed', 'Upside::UCD::CartBuilt'].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleRefresh);
      window.addEventListener(eventName, scheduleRefresh);
    });

    document.addEventListener('dsrcv:shipping-quote-updated', function () {
      if (modeForSurface('product') === 'core' && !selectedProductVariantIsAvailable()) {
        prepareProductRender(true);
      }
    });

    document.addEventListener('change', function (event) {
      if (event.target && event.target.closest && event.target.closest('.ProductForm')) scheduleRefresh();
    });

    var cartDrawer = document.getElementById('sidebar-cart');
    if (
      cartDrawer &&
      modeForSurface('cart') !== 'order_deadline' &&
      typeof MutationObserver === 'function'
    ) {
      var observedDrawerVisibility = cartDrawer.getAttribute('aria-hidden');
      new MutationObserver(function () {
        var nextDrawerVisibility = cartDrawer.getAttribute('aria-hidden');
        if (nextDrawerVisibility === observedDrawerVisibility) return;
        observedDrawerVisibility = nextDrawerVisibility;
        if (nextDrawerVisibility === 'false') refreshCart(true);
      }).observe(cartDrawer, {
        attributes: true,
        attributeFilter: ['aria-hidden']
      });
    }

    var preorderWrapper = document.querySelector('.custom-cart-wrapper');
    if (preorderWrapper && typeof MutationObserver === 'function') {
      var observedPreorderState = preorderWrapper.getAttribute('data-preorder-active');
      var observedSelectionState = preorderWrapper.getAttribute('data-variant-selected');
      new MutationObserver(function () {
        var nextPreorderState = preorderWrapper.getAttribute('data-preorder-active');
        var nextSelectionState = preorderWrapper.getAttribute('data-variant-selected');
        if (
          nextPreorderState === observedPreorderState &&
          nextSelectionState === observedSelectionState
        ) return;
        observedPreorderState = nextPreorderState;
        observedSelectionState = nextSelectionState;
        scheduleRefresh();
      }).observe(preorderWrapper, {
        attributes: true,
        attributeFilter: ['data-preorder-active', 'data-variant-selected']
      });
    }

    if (typeof MutationObserver === 'function') {
      var hasCoreSurface = modeForSurface('product') === 'core' || modeForSurface('cart') === 'core';
      var hasShadowSurface = modeForSurface('product') === 'shadow' || modeForSurface('cart') === 'shadow';
      if (hasCoreSurface || hasShadowSurface) {
        if (hasCoreSurface) keepLegacyHidden();
        legacyObserver = new MutationObserver(function (mutations) {
          if (hasCoreSurface && Array.prototype.some.call(mutations, mutationIncludesLegacyNode)) keepLegacyHidden();
          if (hasShadowSurface) refreshWhenLegacyArrives(mutations);
        });
        legacyObserver.observe(document.body, hasShadowSurface ? {
          attributes: true,
          attributeFilter: ['class', 'style'],
          childList: true,
          subtree: true
        } : { childList: true, subtree: true });
      }
    }
  }

  // Share the existing calendar calculation with the cart totals. Never reuse
  // a promise from a different market/basket. Unchanged drawer opens retain it.
  function currentCartPromiseState(countryCode, subtotalCents) {
    var state = lastCartRender && lastCartRender.state;
    if (modeForSurface('cart') !== 'core' || !state || state.countryCode !== countryCode || state.countryCode !== cartCountry() || state.currencyCode !== currentCurrency() || state.clockKey !== currentClockKey() ||
      !Number.isSafeInteger(subtotalCents) || state.subtotalCents !== subtotalCents ||
      (state.cartKey && drawerCartKey() !== null && state.cartKey !== drawerCartKey())) return null;
    return state;
  }

  window.dsrcvGetCartDeliveryMessage = function (countryCode, subtotalCents) {
    return cartPromiseMessage(currentCartPromiseState(countryCode, subtotalCents));
  };

  // A restrained deadline only when Core confirms dispatch today for the current basket.
  window.dsrcvGetCartDeliveryBenefit = function (countryCode, subtotalCents) {
    var state = currentCartPromiseState(countryCode, subtotalCents);
    if (!state || !state.itemCount) return null;
    var summary = { title: cartPromiseMessage(state), subtitle: '' };
    var result = lastCartRender.result;
    var now = londonNowParts();
    var today = [now.year, String(now.month).padStart(2, '0'), String(now.day).padStart(2, '0')].join('-');
    if (!result || result.visible !== true || result.cutoffPassed !== false || result.dispatchDate !== today ||
        now.hour >= cutoffHour() || !state.hasNonPreorder || state.unresolvedPreorder ||
        !Array.isArray(result.handlingDays) || !result.handlingDays.length || result.handlingDays.some(function (days) { return days !== 0; })) return summary;
    if (countryCode === 'GB') {
      var tomorrow = dateKey(addDays(dateFromKey(today), 1));
      if (result.deliveryDateMin !== tomorrow || result.deliveryDateMax !== tomorrow) return summary;
      summary.title = state.hasPreorder ? 'In-stock pieces delivered tomorrow' : 'Delivered tomorrow';
      summary.subtitle = 'Order before ' + clockLabel({ hour: cutoffHour(), minute: 0 }) + ' today';
    } else if (!state.hasPreorder) {
      summary.title = 'Same-day dispatch';
      summary.subtitle = internationalCutoffLabel({ now: now });
    }
    return summary;
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
